import { ClientType } from "src/api/v1/project-ApiSlice";
import { IMAGE_HOST } from "src/utils/constants";
import { CategoryDescription } from "src/model/api/quote/get-quote-response.model";

import { Fragment, useEffect, useState } from "react";
import { ErrorBoundary } from "src/components/ErrorBoundary/ErrorBoundary";
import { SubCategory } from "src/pages/OfferPage/FunctionDescription/Category/SubCategory/SubCategory";
import DOMPurify from "dompurify";

export const Category = (
    props: {
      key: number,
      category: CategoryDescription,
      clientType: ClientType
    }
  ) => {
  const { category, clientType } = props;

  const [hasDescription, setHasDescription] = useState(false);

  useEffect(() => {
    function checkDescription(category: CategoryDescription) {
      if (
        category.descriptions[clientType].desc !== null &&
        category.descriptions[clientType].desc !== ''
      ) {
        return true;
      }

      if (category.sub_categories && Object.keys(category.sub_categories).length) {
        return Object.values(category.sub_categories).some((subcategory: any) =>
          subcategory.descriptions[clientType] && subcategory.descriptions[clientType].desc !== null &&
          subcategory.descriptions[clientType] && subcategory.descriptions[clientType].desc !== '' ||
          (subcategory.products && Object.keys(subcategory.products).length &&
            Object.values(subcategory.products).some((product: any) =>
              product.descriptions[clientType] && product.descriptions[clientType].desc !== null &&
              product.descriptions[clientType] && product.descriptions[clientType].desc !== ''
            )
          )
        );
      }
      return false;
    }

    setHasDescription(checkDescription(category));

  }, [category, clientType]);

  return (
    <Fragment>
      {hasDescription ? (
        <Fragment>
          <ErrorBoundary>
            {category.base_image ? (
              <div
                className="function-description"
                style={{
                  paddingTop: 15,
                  paddingBottom: 20,
                }}
              >
                <img
                  src={`${IMAGE_HOST}${category.base_image}`}
                  style={{
                    width: "100%",
                  }}
                />
              </div>
            ) : null}
            <div className="break-inside-avoid">
              <h4
                  className="function-description"
                  style={{
                      fontFamily: "Open Sans",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "24px",
                      letterSpacing: "-0.154px",
                  }}
              >{category.name}</h4>
              <div
                style={{
                  paddingTop: 5,
                  paddingBottom: 10,
                }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(category.descriptions[clientType].desc),
                }}
              />
            </div>
          </ErrorBoundary>
          {category.sub_categories &&
            !Array.isArray(category.sub_categories) &&
            Object.keys(category.sub_categories).length ? (
              <Fragment>
                {Object.keys(category.sub_categories).map(
                  (subCategory, subCategoryKey) => (
                    <SubCategory
                      key={subCategoryKey}
                      subCategory={category.sub_categories[subCategory]}
                      clientType={clientType}
                    />
                  )
                )}
              </Fragment>
            ) : null}
        </Fragment>
      ) : null}
    </Fragment>
  );
};
